import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Frontend belt-and-braces gate for /admin/* routes.
 * Backend already enforces admin via require_admin on every /admin endpoint,
 * but this prevents the page chrome / sidebar from briefly rendering for
 * non-admin users who type the URL directly.
 */
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="p-8 text-sm text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}
